module.exports = __webpack_public_path__ + "img/footerlogo.fd7d9320.png";